import React, {Component} from 'react'
import { Alert, ArticleNav, Video } from '../../../components'
import { CounterfeitStyle, CounterfeitContentStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'

class Counterfeit extends Component {
  state = {
    data: {}
  }

  render () {
    const { data, isReady } = this.props
    return (
      <div className={`counterfeit ${CounterfeitStyle} transition ${isReady ? 'transition--ready': ''}`}>
      {
        data && (
          <div className="flex">
            <ArticleNav is_bookmark={data.is_bookmark} pdf={data.pdf} slug_bookmark={data.slug_bookmark} type={data.type} classname='news-nav' />
            <div className="counterfeit-content">
              <h2 className="counterfeit-title"><Alert width={48} height={48} /> { data.title }</h2>
              <div className="counterfeit-intro content" dangerouslySetInnerHTML={{'__html': data.intro}} />
              {
                data.sub_title && (
                  <div className="counterfeit-subtitle">
                    {data.sub_title}
                  </div>
                )
              }
              
              <div className="counterfeit-blocs">
                {
                  data.blocks && data.blocks.map((bloc, index) => (
                    <div className="counterfeit-bloc bloc" key={index} >
                      {
                        bloc.type === 'video' && (
                          <div>
                            <div className="bloc-title">
                                {bloc.fields.title}
                            </div>
                            {
                              bloc.fields.link && (
                                <Video {...bloc.fields} title='' label='play the video' type='vimeo'></Video>
                              )
                            }
                            <div className="bloc-content content" dangerouslySetInnerHTML={{'__html': bloc.fields.description}} />
                          </div>
                        )
                      }

                      {
                        bloc.type === 'content' && (
                          <div>
                            <div className="bloc-title">
                              {bloc.fields.title}
                            </div>
                            <div className="flex">
                              {/* LEFT */}
                              <div className={`bloc-content ${CounterfeitContentStyle(bloc.fields.image_left.url)}`}>
                                {
                                  bloc.fields.image_left.url &&  (
                                    <div className="bloc-picture">
                                      <div className="bloc-picture__picture"></div>
                                      <div className="bloc-picture__legend">{bloc.fields.image_legend_left}</div>
                                    </div>
                                  )
                                }
                                <div className="content" dangerouslySetInnerHTML={{'__html': bloc.fields.text_left}} />
                              </div>

                              {/* RIGHT */}
                              <div className={`bloc-content ${CounterfeitContentStyle(bloc.fields.image_right.url)}`}>
                                {
                                  bloc.fields.image_right.url &&  (
                                    <div className="bloc-picture">
                                      <div className="bloc-picture__picture"></div>
                                      <div className="bloc-picture__legend">{bloc.fields.image_legend_right}</div>
                                    </div>
                                  )
                                }
                                <div className="content" dangerouslySetInnerHTML={{'__html': bloc.fields.text_right}} />
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  ))
                }
              </div>
            </div>  
          </div>
        )
      }
      </div>
    )
  }
}

export default withLoader(Counterfeit, `/alerts/counterfeits`, true)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Counterfeit.js